
<div class="content content-form d-flex flex-column flex-column-fluid">

    <ng-container>
        <div class="mt-3">
           <h3 class="text-center">CHÀO MỪNG BẠN ĐÃ ĐẾN VỚI PHẦN MỀM QUẢN LÝ THÔNG TIN HÀNH NGHỀ Y DƯỢC</h3>
           <div class="text-center">Xin vui lòng chọn một chức năng tại menu bên trái để tiếp tục</div>
        </div>
    </ng-container>
</div>
